import React from 'react';

const TaskHistoryModal = ({ isOpen, toggleModal, tasks }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-color rounded-lg p-6 w-full max-w-md">
        <h3 className="text-2xl font-bold mb-4">Historial de Tareas</h3>
        <ul className="list-disc list-inside">
          {tasks.map((task, index) => (
            <li key={index} className="mb-2">
              <span className="font-semibold">{`Día ${task.day}:`}</span>{' '}
              {`${task.participant.name} en ${task.location.name} - ${task.status}`}
              {task.postponements > 0 && ` (Pospuesto ${task.postponements} veces)`}
            </li>
          ))}
        </ul>
        <button
          onClick={toggleModal}
          className="mt-6 p-2 bg-blue-600 text-white rounded-lg w-full"
        >
          Cerrar
        </button>
      </div>
    </div>
  );
};

export default TaskHistoryModal;
